<template lang="html">
  <div id="results-page">

    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <span>Categorías</span>


      </div>
    </section>

    <section class="container oversized-container products-section">


      <div class="row align-items-start">

        <!-- Mobile filters -->
         <div class="col-12 col-filters-mobile">
          <div class="bg-filter-mv" v-if="showFilters == true" @click="showFilters = false"></div>
          <a class="btn-filters" @click="showFilters = !showFilters">
            <i class="fas fa-filter"></i><span>Ver filtros</span>
          </a>
        </div>

        <div class="col-lg col-filters" v-bind:class="{ 'show-filters': showFilters == true }">
          <h4 class="_title">
            <span>Filtros de Búsqueda</span>
            <a class="btn-hide" @click="showFilters = false"><i class="fas fa-chevron-left"></i></a>
          </h4>

          <b-form class="filters-container" @submit="onSubmitFilters">

            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Precio</a>

              <div class="box-filters-group">
                <b-form-select class="c-filter-select" v-model="filtersForm.price">
                  <b-form-select-option :value="null">Cualquiera</b-form-select-option>
                  <b-form-select-option :value="800">$800 o menos</b-form-select-option>
                  <b-form-select-option :value="1499">$1,499 o menos</b-form-select-option>
                  <b-form-select-option :value="999999999999999999">$1,500 o más</b-form-select-option>
                </b-form-select>
              </div>
            </div>

            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Marca</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.brands"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="br.id" v-for="(br,indx) in brandsOpcs" :key="'bra'+indx">{{br.name}}</b-form-checkbox>

                </b-form-checkbox-group>
              </b-form-group>
            </div>

            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Categoria</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.categories"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="subc.id" v-for="(subc,indx) in categoriesOpcs" :key="'subca'+indx">{{subc.name}}</b-form-checkbox>

                </b-form-checkbox-group>
              </b-form-group>
            </div>



          </b-form>
        </div>
        <!--  -->

        <!-- Resultados en columnas -->
        <div class="col-lg">
          <div class="row">
            <div class="col-12 mb-4 col-order">
              <div class="txt">
                Ordenar por:
              </div>

              <b-form-select v-model="filtersForm.order" class="mb-3">
                <b-form-select-option value="1">Precio Menor a mayor</b-form-select-option>
                <b-form-select-option value="2">Precio Mayor a menor</b-form-select-option>
                <b-form-select-option value="3">Alfabeto</b-form-select-option>
              </b-form-select>
            </div>
          </div>

          <div class="row sample-products-wrapper xxl-4e" v-if="!isLoading">
            <div class="col-sm-6 col-md-6 col-xl-4 sample-product shad-prod" v-for="(product, index) in products" :key="index">
              <router-link class="outlined-box" :to="'/producto/'+ $root._converToURL(product.name, product.id)">
                <div class="box-image">
                  <div class="note" v-if="product.isNew">Nuevo</div>
                  <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                    <img src="public/images/shared/empty.png" >
                  </div>
                </div>

                <div class="box-shot-descr">
                  <h6 class="brand">{{ product.sku }}</h6>
                  <h6 class="name">{{ product.name }}</h6>
                  <!-- <h6 class="price discount"><span>$ {{ product.price }}</span></h6> -->
                  <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h6>
                </div>
                <p class="p-button">
                  <a class="btn-more">Ver más</a>
                </p>
              </router-link>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center" v-if="!products.length && !isLoading">
              <h5>No se encontraron resultados</h5>
            </div>

            <div class="col-12" v-if="isLoading">
              <loading-component></loading-component>
            </div>
          </div>
        </div>
        <!--  -->

      </div>

    </section>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data(){
    return{
      isLoading: true,
      showFilters: false,

      filtersForm: {
        brands:[],
        categories:[],
        price:null,
        order: 1,
      },

      products: [],

      category: [],
      category_id:null,
      brandsOpcs:[],
      categoriesOpcs:[],
    }
  },

  watch: {
    "$route.params.id" : function(v){
      this.filtersForm.categories = [];

      this.filtersForm.categories.push(this.$root._getURLID(this.$route.params.id));


    },
    "filtersForm.brands" : function(v){
        this.getProductsCategory(this.category_id);
    },
    "filtersForm.categories" : function(v){
        this.getProductsCategory(this.category_id);
    },
    "filtersForm.price" : function(v){
        this.getProductsCategory(this.category_id);
    },
  },

  methods: {
    onSubmitFilters(evt) {
        evt.preventDefault();

    },

    getProductsCategory: function(category_id){
        this.isLoading = true;
        // axios.post('https://lutherr.com/api/products',this.filtersForm).then((response) =>{
        axios.post(tools.url('/api/products'),this.filtersForm).then((response) =>{
            this.products = response.data;

            this.isLoading = false;
        }).catch((error)=>{
          console.log(error);
        });
    },
    getBrandsOpcs(){
      axios.get(tools.url('/api/brands')).then((response)=>{
        this.brandsOpcs = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },
    getCategoriesOpcs(){
      axios.get(tools.url('/api/categories')).then((response)=>{
        this.categoriesOpcs = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },


  },

  mounted(){

    setTimeout( ()=>{ this.isLoading = false; }, 2000); // ejemplo de "loading" despues de cargar

    if(this.$route.params.id){
       this.filtersForm.categories.push(this.$root._getURLID(this.$route.params.id));

       this.getBrandsOpcs();
        this.getCategoriesOpcs();
    }
  },
}
</script>
